// extracted by mini-css-extract-plugin
export default {"wrapper":"Card_wrapper__+jZHY","imgWrapper":"Card_imgWrapper__hebKi","textWrapper":"Card_textWrapper__e3fpT","button":"Card_button__FUwwJ"};